/** @format */
import { css } from 'styled-components';

const baseStyles = css`
    text-align: center;

    .product-condition-description-content {
        margin-bottom: var(--layout-spacing-24);
    }
`;

export const styles = () => css`
    ${baseStyles}
`;
